import { Icon } from '@ps/isp-web-component-library';
import { Ninety } from '@ps/isp-web-component-library/icons/Ninety';
import { StarSubIcon } from '@ps/isp-web-component-library/icons/StarSubIcon';
import { TwoUpIcon } from '@ps/isp-web-component-library/icons/TwoUpIcon';
import { getIsMatchOddsNinetyMarket, getIsTwoUpMarket } from '@ps/web-sports-utils';
import classNames from 'clsx';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import AnimatedInPlayIcon from '../AnimatedInPlayIcon/AnimatedInPlayIcon';

import type { MeetingBasedDescriptionProps } from './MeetingBasedDescription';
import { MeetingBasedDescription } from './MeetingBasedDescription';
import {
  TXTWCL_Match_Odds_90,
  TXTWCL_Match_Odds___2_Up,
  TXTWCL_Star_Sub_enabled_selection
} from './OpportunityDescription.messages.json';
import styles from './OpportunityDescrption.scss';

interface Props extends MeetingBasedDescriptionProps {
  className?: string;
  isStarSubEnabled?: boolean;
  isEventInPlay?: boolean;
  marketType?: string;
}

export const OpportunityDescription: React.FC<Props> = ({
  className,
  description,
  venue,
  marketTime,
  variant,
  isStarSubEnabled,
  isEventInPlay,
  marketType
}) => {
  const { formatMessage } = useRegulatoryIntl();

  const isMatchOddsNinetyMarket = getIsMatchOddsNinetyMarket(marketType);
  const isTwoUpMarket = getIsTwoUpMarket(marketType);

  if (venue) {
    return (
      <MeetingBasedDescription
        variant={variant}
        className={className}
        marketTime={marketTime}
        venue={venue}
        description={description}
      />
    );
  }

  return (
    <span className={classNames(className, styles.opportunityDescription)}>
      {description}
      {isEventInPlay ? <AnimatedInPlayIcon className={styles.inPlayIcon} /> : null}
      {isStarSubEnabled ? (
        <Icon
          icon={StarSubIcon}
          className={styles.marketIcon}
          label={formatMessage(TXTWCL_Star_Sub_enabled_selection)}
          size="xs"
        />
      ) : null}
      {isMatchOddsNinetyMarket ? (
        <Icon
          icon={Ninety}
          className={styles.marketIcon}
          label={formatMessage(TXTWCL_Match_Odds_90)}
          size="xs"
        />
      ) : null}
      {isTwoUpMarket ? (
        <Icon
          icon={TwoUpIcon}
          className={styles.marketIcon}
          label={formatMessage(TXTWCL_Match_Odds___2_Up)}
          size="xs"
        />
      ) : null}
    </span>
  );
};
